import script from "./Process.vue?vue&type=script&lang=ts&setup=true"
export * from "./Process.vue?vue&type=script&lang=ts&setup=true"

import "./Process.vue?vue&type=style&index=0&id=12110ca4&lang=less"

const __exports__ = script;

export default __exports__